import { Grid } from '@mui/material';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import { FormControlLabel } from '@mui/material';
import { Checkbox } from '@mui/material';

interface SonUnknownParentsProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  configuration?: string;
}

const SonUnknownParentsComponent = ({
  disabled = false,
  values,
  onChange,
}: SonUnknownParentsProps): React.ReactElement => {
  return (
    <Grid container spacing={2} item>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              id="isSonUnknownParents"
              checked={values?.isSonUnknownParents || false}
              onChange={() => {
                onChange('isSonUnknownParents', !values?.isSonUnknownParents);
              }}
              inputProps={{ 'aria-label': 'Figlio di ignoti' }}
              disabled={disabled}
            />
          }
          label="Figlio di ignoti"
        />
      </Grid>
    </Grid>
  );
};

SonUnknownParentsComponent.displayName = 'Son Unknown Parents component';

const SonUnknownParents = memo(SonUnknownParentsComponent);

export default SonUnknownParents;
